import AsyncStorage from '@react-native-async-storage/async-storage';

interface TokenCache {
  getToken: (key: string) => Promise<string | undefined | null>;
  saveToken: (key: string, token: string) => Promise<void>;
  clearToken: (key: string) => void;
}

const createTokenCache = (): TokenCache => {
  return {
    getToken: async (key: string) => {
      try {
        const item = await AsyncStorage.getItem(key);
        return item;
      } catch (error) {
        console.error('secure store get item error: ', error);
        await AsyncStorage.removeItem(key);
        return null;
      }
    },
    saveToken: (key: string, token: string) => {
      return AsyncStorage.setItem(key, token);
    },
    clearToken: (key: string) => {
      return AsyncStorage.removeItem(key);
    }
  };
};

export const tokenCache = createTokenCache();
